<template>
  <span
    :class="
      twMerge(
        'bg-gray-600 h-[20px] text-white text-xs font-normal me-2 px-2.5 py-0.5 rounded-sm',
        $attrs.class
      )
    "
  >
    <slot></slot>
  </span>
</template>
<script setup>
import { twMerge } from 'tailwind-merge'
</script>
